import axiosClient from "../../shared/components/requests/axiosCLient";
import { API_URLS } from "../../shared/constants/constants";

export const getServiceDetails = (id) => {
  const url = API_URLS.servicePage(id);
  return axiosClient.get(url);
};
